import React from 'react';
import Tabs from '../Tabs/Tabs.js';
function HeaderTabs({ tabsConfig, activeTab, onChange }) {
    return (React.createElement(Tabs, { active: activeTab, onChange: onChange }, tabsConfig?.map(({ storeId, label }) => (React.createElement(Tabs.Tab, { key: storeId, value: storeId }, label)))));
}
export default HeaderTabs;
//# sourceMappingURL=HeaderTabs.js.map